import { FiFolder } from 'react-icons/fi'

import { t } from 'i18next'

import ThumbVideoZoomable from '~/components/ThumbVideoZoomable'
import ThumbZoomable from '~/components/ThumbZoomable'
import { isAdvertiser, isReadOnly } from '~/helpers'
import HandleAdsActive from '~/modules/retailMedia/components/HandleAdsActive'
import { TagNewItem } from '~/modules/retailMedia/components/TagNewItem'

import * as S from './styles'

const AdInfo: RowComponent = data => {
  const showToggle =
    isAdvertiser() && data.ad_type !== 'sponsored_brand' && !isReadOnly()
  const logoUrl = data.campaign_settings.brand_url

  return (
    <S.TitleWrapper>
      {/* Toggle para gerenciar atividade do anúncios. Apenas advertiser */}
      {showToggle && (
        <aside>
          <HandleAdsActive key={data.id} data={data} isolatedAd />
        </aside>
      )}

      {['sponsored_brand', 'sponsored_brand_video'].includes(data.ad_type) && (
        <>
          <ThumbZoomable
            url={logoUrl}
            title={data.campaign_settings.brand_name}
          />

          <div className="mainInfo">
            <div>
              <strong className="brand_name">
                {t('rm:campaign.create.SponsoredBrand.elements.brandName')}
              </strong>
              : {data?.campaign_settings?.brand_name || '-'}
            </div>
            <div>
              <strong className="headline">
                {t('rm:campaign.create.SponsoredBrand.elements.title')}
              </strong>{' '}
              : {data?.campaign_settings?.headline || '-'}
            </div>
            <div>
              <strong className="description">
                {t('rm:campaign.create.SponsoredBrand.elements.description')}
              </strong>
              : {data?.campaign_settings?.description || '-'}
            </div>

            <div>
              <span className="description" title="Data de criação">
                <TagNewItem created={data.created_at} />
              </span>
            </div>
          </div>
        </>
      )}

      {data.ad_type === 'product' && (
        <>
          <ThumbZoomable url={data.image_url} title={data.name} />

          <div className="mainInfo">
            {!!data?.categories?.length && (
              <div className="text-sm text-gray">
                <span
                  className="d-inline-flex me-1"
                  style={{ transform: 'translateY(1px)' }}
                >
                  <FiFolder />
                </span>
                <span>{data?.categories?.at(-1)}</span>
              </div>
            )}

            <strong className="title">{data.name}</strong>
            <span className="description">SKU: {data.product_sku}</span>
            <TagNewItem created={data.created_at} />
          </div>
        </>
      )}

      {data.ad_type === 'banner' && (
        <>
          <ThumbZoomable
            url={data.settings.media_url}
            title={data.media_size}
          />

          <div className="mainInfo">
            <small>
              <strong>{t('rm:Format')}:</strong> {data.settings.ad_size}
            </small>
            <br />
            <span className="description" title="Data de criação">
              <TagNewItem created={data.created_at} />
            </span>
          </div>
        </>
      )}

      {data.ad_type === 'banner_video' && (
        <>
          <ThumbVideoZoomable url={data.settings.media_url} size="tiny" />

          <div className="mainInfo">
            <small>
              <strong>{t('rm:Format')}:</strong> {data.settings.ad_size}
            </small>
            <br />
            <span className="description" title="Data de criação">
              <TagNewItem created={data.created_at} />
            </span>
          </div>
        </>
      )}

      {data.ad_type === 'banner_off_site' && (
        <>
          <ThumbZoomable
            url={data.settings.media_url}
            title={data.media_size}
          />

          <div className="mainInfo">
            <small>
              <strong>{t('rm:Format')}:</strong> {data.settings.ad_size}
            </small>
            <br />
            <span className="description" title="Data de criação">
              <TagNewItem created={data.created_at} />
            </span>
          </div>
        </>
      )}
    </S.TitleWrapper>
  )
}

export default AdInfo
